import { useActivityFeed } from "./LedgerEventsProvider";
import Instant from "./Instant";
import type { LedgerEvent } from "../sse";

function eventLabel(event: LedgerEvent): string {
  const number = event.runNumber ?? event.data.run_number;
  const run = number != null ? `run #${number}` : "";
  switch (event.type) {
    case "run_created":
      return `Created ${run}`.trim();
    case "run_status_changed":
    case "status_changed":
      return `${run} → ${event.data.status ?? "status changed"}`.trim();
    case "result_recorded":
      return `Result recorded ${run}`.trim();
    case "verdict_pending":
      return `Pending triage: ${event.data.pending_count ?? ""}`.trim();
    case "verdict_created":
      return `Verdict created ${run}`.trim();
    case "verdict_reviewed":
      return `Verdict reviewed ${run}`.trim();
    case "verdict_updated":
      return `Verdict updated ${run}`.trim();
    case "coverage_updated":
      return `Coverage updated ${run}`.trim();
    case "reduction_complete":
      return `Reduction complete ${run}`.trim();
    case "scenario_changed":
      return `Scenario ${event.data.dispatch_status ?? "changed"} ${run}`.trim();
    case "finding_changed":
      return `Finding recorded ${run}`.trim();
    case "finding_graduated":
      return `Finding graduated ${run}`.trim();
    case "report_changed":
      return `Report updated ${run}`.trim();
    case "report_published":
      return `Report published ${run}`.trim();
    case "resync":
      return "Resyncing…";
    default:
      return event.type.replaceAll("_", " ");
  }
}

/** The live event feed, rendered in a drawer rather than as a page section. */
export default function ActivityFeed() {
  const feed = useActivityFeed();
  if (feed.length === 0) {
    return <p className="text-sm opacity-60">Waiting for live events…</p>;
  }
  return (
    <ul className="menu rounded-lg" aria-live="polite">
      {feed.map((e, i) => (
        <li key={`${e.at}-${i}`} className="flex-row items-center gap-3 px-3 py-2">
          <span className="badge badge-ghost badge-sm">{e.type}</span>
          <span className="text-sm">{eventLabel(e)}</span>
          <span className="text-xs opacity-50 ml-auto">
            <Instant iso={e.at} style="time" />
          </span>
        </li>
      ))}
    </ul>
  );
}
